import { API } from './config'

export const addEntityReview = (
  teacherId,
  entityId,
  entityType,
  entitySubType,
  entityReview,
  entityRating,
) =>
  API.post(`/review/v2`, {
    teacherId,
    entityId,
    entityType,
    entitySubType,
    entityReview,
    entityRating,
  })
    .then(() => true)
    .catch(() => false)
